<template>
  <div class="personalCard">
    <div :class="type == 'line' ? 'leftLine' : 'left'">
      <slot name="left"></slot>
    </div>
    <div class="right">
      <slot name="right"></slot>
    </div>
    <slot name="status"></slot>
  </div>
</template>

<script>

export default {
  data() {
    return {
    };
  },

  props: ['type'],

  methods: {
    
  },

  created() {
    
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
.personalCard{
  margin: 0.5rem;
  border-radius: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.2rem 0;
  position: relative;
  overflow: hidden;
  .left{
    width: 2rem;
    min-height: 2rem;
    margin-right: 0.2rem;
    position: relative;
    &:after{
      position: absolute;
      content: '';
      display: inline-block;
      right: 0;
      height: 90%;
      top: 5%;
      width: 0.1rem;
      border-radius: 0.2rem;
    }
  }
  .leftLine{
    width: 1.8rem;
    min-height: 2.5rem;
    margin-right: 0.1rem;
    position: relative;
    // background: url('../../assets/line2.png') 95% 0/contain no-repeat;
    // &:after{
    //   position: absolute;
    //   content: '';
    //   display: inline-block;
    //   right: -1rem;
    //   top: 1.1rem;
    //   height: 0.2rem;
    //   width: 2.5rem;
    //   background: url('../../assets/line.png') 0 0/100% no-repeat;
    //   transform: rotate(90deg);
    // }
  }
  .tuan{
    position: absolute;
    height: 1.5rem;
    width: 1.5rem;
    top: -0.15rem;
    right: -0.2rem;
  }
}
</style>
<style type="text/css" lang="scss">
  .pcItemCard{
    .personals{
      flex-wrap: wrap;
    }
    .personalCard{
      width: 47%;
      overflow: hidden;
      margin: 0.3rem 3% 0.3rem 0.05rem;
      background-color: #fff;
      padding: 0;
      border-radius:20px;
      .right{
        padding: 10px;
        overflow: hidden;
      }
      .leftLine{
        // width: 0.3rem;
        padding: 0.05rem 0.2rem;
        padding-left: 0.1rem;
        min-height: 1.2rem;
        margin-right: 0.1rem;
        margin: 0.1rem 0;
        max-width: 0.8rem;
        .leftName{
          font-size: 0.2rem;
          line-height: 0.25rem;
          max-width: 0.5rem;
          height: 1.6rem;
          letter-spacing: 0.05rem;
        }
      }
      .right{
        .detail{
          line-height: 0.3rem;
          .name{
            font-size: 18px;
            color: #999999;
          }
          .title{
            font-size: 22px;
            margin-right: 15px;
          }   
        }
        .rightContent{
          .detail{
            line-height: 32px;
          }
          width: 350px !important;
        }
        .buttonCancel, .buttonConfirm{
          width: 120px;
          height: 40px;
          font-size: 20px;
          line-height: 40px;
          text-align: center;
          margin: 15px;
        }
        .buttonCancel{
          border-width: 1px;
        }
        .tuan{
          height: 50px;
          width: 50px;
          top: 0px;
          right: 0px;
        }
      }
    }
  }
</style>
